import { syncInGameCompensationRewards } from "@/event/session/syncInGameCompensationRewards";

const REWARD_POLL_DELAYS_MS = [0, 3_000, 12_000] as const;

/**
 * Server milestone grants run in the end-of-event cleanup pipeline (async).
 * Poll a few times so online players receive compensation rewards in the UI
 */
export function refreshInGameRewardsAfterEventEnd(): void {
	for (const delayMs of REWARD_POLL_DELAYS_MS) {
		window.setTimeout(() => {
			syncInGameCompensationRewards();
		}, delayMs);
	}
}
